import script from "./ServiceInstanceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceInstanceModal.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceInstanceModal.vue?vue&type=style&index=0&id=47b8534d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b8534d"]])

export default __exports__